function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic /2/ arrow copy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Life-at-WG",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-/-Life_Lifestyle",
  transform: "translate(-1840.000000, -2628.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(1728.000000, 2411.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-/2/-arrow",
  transform: "translate(136.000000, 233.000000) scale(-1, 1) translate(-136.000000, -233.000000) translate(104.000000, 201.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "baseline-keyboard_backspace-24px"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 64 0 64 64 0 64"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FF614D",
  points: "56 29.3333333 18.2133333 29.3333333 27.76 19.76 24 16 8 32 24 48 27.76 44.24 18.2133333 34.6666667 56 34.6666667"
}))))));

var SvgArrowOrange = function SvgArrowOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "32px",
    viewBox: "0 0 48 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-orange.68bd787e.svg";
export { ForwardRef as ReactComponent };